import { FC, useState } from "react";
import { BrgButton, ButtonVariant, FlexBox } from "@brg/ui";
import { useModal } from "core";
import { useTranslation } from "react-i18next";
import { ConfirmContent, ConfirmText, ConfirmWrapper } from "./styles";

interface ConfirmCourseActionModalProps {
    text: string;
    confirmLabel: string;
    onConfirm: () => Promise<void>;
    onSuccess?: () => void;
}

export const ConfirmCourseActionModal: FC<ConfirmCourseActionModalProps> = ({
    text,
    confirmLabel,
    onConfirm,
    onSuccess,
}) => {
    const modal = useModal();
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(false);

    const handleConfirm = () => {
        setIsLoading(true);
        onConfirm()
            .then(() => {
                onSuccess?.();
                modal.hide();
            })
            .finally(() => setIsLoading(false));
    };

    return (
        <ConfirmWrapper>
            <ConfirmContent direction="column">
                <ConfirmText>{text}</ConfirmText>
                <FlexBox gx={16} direction="row" directionMobile="column" gyMobile={12} style={{ width: '100%' }}>
                    <BrgButton fullWidth variant={ButtonVariant.Hollow} onClick={() => modal.hide()} style={{ flex: 1 }}>
                        {t('teams.adminPage.courseCard.cancel')}
                    </BrgButton>
                    <BrgButton fullWidth variant={ButtonVariant.Filled} onClick={handleConfirm} disabled={isLoading} style={{ flex: 1 }}>
                        {confirmLabel}
                    </BrgButton>
                </FlexBox>
            </ConfirmContent>
        </ConfirmWrapper>
    );
};
import { FC, useState } from "react";
import { BrgButton, ButtonVariant, FlexBox } from "@brg/ui";
import { useModal } from "core";
import { useTranslation } from "react-i18next";
import { ConfirmContent, ConfirmText, ConfirmWrapper } from "./styles";

interface ConfirmCourseActionModalProps {
    text: string;
    confirmLabel: string;
    onConfirm: () => Promise<void>;
    onSuccess?: () => void;
}

export const ConfirmCourseActionModal: FC<ConfirmCourseActionModalProps> = ({
    text,
    confirmLabel,
    onConfirm,
    onSuccess,
}) => {
    const modal = useModal();
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(false);

    const handleConfirm = () => {
        setIsLoading(true);
        onConfirm()
            .then(() => {
                onSuccess?.();
                modal.hide();
            })
            .finally(() => setIsLoading(false));
    };

    return (
        <ConfirmWrapper>
            <ConfirmContent direction="column">
                <ConfirmText>{text}</ConfirmText>
                <FlexBox gx={16} direction="row" directionMobile="column" gyMobile={12} style={{ width: '100%' }}>
                    <BrgButton fullWidth variant={ButtonVariant.Hollow} onClick={() => modal.hide()} style={{ flex: 1 }}>
                        {t('teams.adminPage.courseCard.cancel')}
                    </BrgButton>
                    <BrgButton fullWidth variant={ButtonVariant.Filled} onClick={handleConfirm} disabled={isLoading} style={{ flex: 1 }}>
                        {confirmLabel}
                    </BrgButton>
                </FlexBox>
            </ConfirmContent>
        </ConfirmWrapper>
    );
};
